var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heading-solid",
    d: "M0,33a1,1,0,0,1,1-1H4a1,1,0,0,1,0,2H3.5v3.5h7V34H10a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2h-.5V44H13a1,1,0,0,1,0,2H10a1,1,0,0,1,0-2h.5V39.5h-7V44H4a1,1,0,0,1,0,2H1a1,1,0,1,1,0-2h.5V34H1A1,1,0,0,1,0,33Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingSolid);
export default __webpack_public_path__ + "static/media/heading-solid.5c5dc211338816a06559afe0957f9e40.svg";
export { ForwardRef as ReactComponent };